import { useState } from "react";
import { useIntl } from "react-intl";
import { FeedbackTypes, FilteringTypes, Filters, Status } from "./BackofficeFeedbackList.model";
import { Field } from '../../components/FiltersForm/FiltersForm.model';
import useObjectHelper from "../../Helpers/useObjectHelper";

export const useBackofficeFeedbackList = () => {
	const [activeFilters, setActiveFilters] = useState<Filters | null>(null);
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const intl = useIntl();
	const { arrToOptionList, cleanObj } = useObjectHelper();
	
	const filterDefaultValues: Record<FilteringTypes, any> = {
		feedbackType: null,
		status: null,
  }

  const filterFields: Field<Record<FilteringTypes, any>>[] = [{
    label: intl.formatMessage({ id: 'formLabels.feedbackType' }),
    name: 'feedbackType',
    options: { alternateTranslationPrefix: 'feedback.types', optionList: arrToOptionList([FeedbackTypes.BugReport, FeedbackTypes.FlagOfAbuse, FeedbackTypes.GeneralFeedback]) },
    placeholder: intl.formatMessage({id: 'formPlaceholders.feedbackType'}),
    type: 'select',
  },{
    label: intl.formatMessage({ id: 'formLabels.status' }),
    name: 'status',
    options: { alternateTranslationPrefix: 'status.feedback', optionList: arrToOptionList([Status.Pending, Status.Resolved, Status.Unassigned]) },
    placeholder: intl.formatMessage({id: 'formPlaceholders.status'}),
    type: 'select',
  },
  ];

  const getFiltersAsQueryParams = (obj: Filters | null) => {
    return obj ? Object.keys(obj).reduce((acc: string[], curr: string) => {
      if (curr !== 'mentorsOnly') {
        acc = [...acc, `${curr}=${obj[curr]}`];
      } else if (obj[curr]) {
        acc = [...acc, `role=Mentor`]
      }
      return acc;
    }, []).join('&') : '';
	};
	
	const onChangeViewMyFeedbacksOnly = async(e: any) => {
		const filters: Filters = {
			...activeFilters,
			myFeedbacksOnly: e.target.checked 
		};

		setActiveFilters(filters);
	}

  const onResetFilters = async (callBack?: () => void) => {
    let filters: Filters = {
      myFeedbacksOnly: activeFilters?.myFeedbacksOnly ? activeFilters.myFeedbacksOnly : false,
    };

    setActiveFilters(filters);

    callBack && callBack();
	};

  const onSubmitFilters = async (data: Filters, callBack?: () => void) => {
    const filters: Filters = {
      ...activeFilters,
      ...cleanObj(data)
    };

    setActiveFilters(filters);

    callBack && callBack();
	};
	
	const toggle = (set: React.Dispatch<React.SetStateAction<boolean>>, value: boolean) => {
    set(!value);
  }

	return {
    filterDefaultValues,
    filterFields,
		getFiltersAsQueryParams,
		onChangeViewMyFeedbacksOnly,
		onResetFilters,
		onSubmitFilters,
    state: { activeFilters, showMobileFilters },
    toggleMobileFilters: () => { toggle(setShowMobileFilters, showMobileFilters) },
  }
}